import { Modal } from '@belong/ui';

type Props = {
  isOpen: boolean;
  onDismiss: () => void;
  url: string;
};

export function IntroStandardsModal({ isOpen, onDismiss, url }: Props) {
  return (
    <Modal
      isOpen={isOpen}
      onDismiss={() => onDismiss()}
      name="belong-standards-modal-iframe"
      size="fullScreen"
      childrenClassName="md:py-0"
      overlayClassName="bg-dark-navy md:bg-white-translucent overflow-y-hidden"
      closeButton={() => null}
    >
      <div className="mx-auto flex h-full w-full flex-col">
        <iframe
          src={url}
          className="h-screen w-full border-0"
          title="Belong Standards"
          allowFullScreen
        />
      </div>
    </Modal>
  );
}
